<p-toolbar styleClass="">
  <ng-template pTemplate="left">
  </ng-template>

  <ng-template pTemplate="right">
    <p-button icon="pi pi-refresh" label="Обновить" styleClass="p-button-success mr-2" (onClick)="reloadTable($event)"
              pTooltip="Обновить таблицу документов" tooltipPosition="top"></p-button>

    <p-button icon="pi pi-undo" label="Сбросить фильтр" styleClass="p-button-success mr-2" (onClick)="clearOrResetTableFilter($event)"
              pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>

    <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info mr-2" (onClick)="onExportData()"
              pTooltip="Экспортировать список документов" tooltipPosition="top" [disabled]="!totalRecentPaidOrders"></p-button>
  </ng-template>
</p-toolbar>

<p-table #ptable3 [value]="paidOrdersList"
         [rows]="10"
         [rowsPerPageOptions]="[10,25,50]"
         [loading]="loading"
         [showCurrentPageReport]="true"
         [totalRecords]="totalRecentPaidOrders"
         [paginator]="true"
         currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} документов"
         sortMode="single"
         sortField="PAIDNOWDATE"
         sortOrder="-1"
         dataKey="DOCID"
         selectionMode="single"
         [(selection)]="paidSelectedDocument"
         [resizableColumns]="true"
         (onRowSelect)="onPaidRowSelect($event)"
         [rowHover]="true"
         rowExpandMode="single"
         stateStorage="local"
         stateKey="dashboardOrders2-state"
         (onStateSave)="onStateSave($event)"
         (onStateRestore)="onStateRestorePaid($event)"
         (onFilter)="onFilterEvent($event)"
         styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn style="width: 3rem !important">...</th>
      <th pResizableColumn pSortableColumn="PAIDNOWDATE" style="width: 5% !important">Дата <p-sortIcon field="PAIDNOWDATE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="PAIDJUSTNOW" style="width: 6% !important">Оплачено <p-sortIcon field="PAIDJUSTNOW"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCNUMBER" style="width: 6% !important">Номер <p-sortIcon field="DOCNUMBER"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCDATE" style="width: 5% !important">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="LOCALCOMP" style="width: 10% !important">Продавец <p-sortIcon field="LOCALCOMP"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="AUTHOR" style="width: 6% !important">Автор <p-sortIcon field="AUTHOR"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="PARTNERNAMESTR" style="width: auto !important">Заказчик <p-sortIcon field="PARTNERNAMESTR"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCSUM" style="width: 6% !important">Сумма <p-sortIcon field="DOCSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="PAYDSUM" style="width: 6% !important">Оплачено <p-sortIcon field="PAYDSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="SHIPSUM" style="width: 6% !important">Отгружено <p-sortIcon field="SHIPSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCNOTE1" style="width: 8% !important">Пр. продавца <p-sortIcon field="DOCNOTE1"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCNOTE2" style="width: 8% !important">Пр. покупателя <p-sortIcon field="DOCNOTE2"></p-sortIcon></th>
    </tr>
    <tr>
      <th pResizableColumn style="width: 3rem">...</th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['PAIDNOWDATE']" [class.hasvalue]="cf3['PAIDNOWDATE']" (input)="ptable3.filter($event.target.value, 'PAIDNOWDATE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['PAIDJUSTNOW']" [class.hasvalue]="cf3['PAIDJUSTNOW']" (input)="ptable3.filter($event.target.value, 'PAIDJUSTNOW', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCNUMBER']" [class.hasvalue]="cf3['DOCNUMBER']" (input)="ptable3.filter($event.target.value, 'DOCNUMBER', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCDATE']" [class.hasvalue]="cf3['DOCDATE']" (input)="ptable3.filter($event.target.value, 'DOCDATE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['LOCALCOMP']" [class.hasvalue]="cf3['LOCALCOMP']" (input)="ptable3.filter($event.target.value, 'LOCALCOMP', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['AUTHOR']" [class.hasvalue]="cf3['AUTHOR']" (input)="ptable3.filter($event.target.value, 'AUTHOR', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['PARTNERNAMESTR']" [class.hasvalue]="cf3['PARTNERNAMESTR']" (input)="ptable3.filter($event.target.value, 'PARTNERNAMESTR', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCSUM']" [class.hasvalue]="cf3['DOCSUM']" (input)="ptable3.filter($event.target.value, 'DOCSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['PAYDSUM']" [class.hasvalue]="cf3['PAYDSUM']" (input)="ptable3.filter($event.target.value, 'PAYDSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['SHIPSUM']" [class.hasvalue]="cf3['SHIPSUM']" (input)="ptable3.filter($event.target.value, 'SHIPSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCNOTE1']" [class.hasvalue]="cf3['DOCNOTE1']" (input)="ptable3.filter($event.target.value, 'DOCNOTE1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCNOTE2']" [class.hasvalue]="cf3['DOCNOTE2']" (input)="ptable3.filter($event.target.value, 'DOCNOTE2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-paidOrdersList let-expanded="expanded">
    <tr [pSelectableRow]="paidOrdersList"
        [class.futuredocs]="paidOrdersList.fd"
        [class.grayout]="paidOrdersList.go"
        [class.underline]="paidOrdersList.ps"
        [class.strikeout]="paidOrdersList.fs"
        [class.partiallypaiddoc]="paidOrdersList.pp"
        [class.notpaiddoc]="paidOrdersList.np"
        [class.fullypaiddoc]="paidOrdersList.fp"
        [class.todaydocuments]="paidOrdersList.td"
        [class.proformadoc]="(paidOrdersList.DOCTYPEID == 12)"
        [class.inorderdoc]="(paidOrdersList.DOCTYPEID == 2)"
        [class.banktransferdoc]="(paidOrdersList.DOCTYPEID == 9)"
        [class.purchorderdoc]="(paidOrdersList.DOCTYPEID == 10)"
        [class.yellowdoc]="(paidOrdersList.DOCTYPEID == 14)"
        [class.specdoc]="(paidOrdersList.DOCTYPEID == 7)"
        [class.shiporderdoc]="(paidOrdersList.DOCTYPEID == 4)"
        [class.invoicedoc]="(paidOrdersList.DOCTYPEID == 1)">
      <td style="max-width: 5rem !important; padding:0.75rem !important;">
        <button type="button" pButton pRipple [pRowToggler]="paidOrdersList"
                class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
      </td>
      <td style="">{{paidOrdersList.PAIDNOWDATE  | date:'dd.MM.yyyy'}}</td>
      <td style="text-align: right">{{paidOrdersList.PAIDJUSTNOW | number:'1.2-2' }}</td>
      <td style="">
        <a [routerLink]="['/edit-document', paidOrdersList.DOCTYPEID, paidOrdersList.DOCID]">
          {{paidOrdersList.DOCNUMBER}}
        </a>
      </td>
      <td style="">{{paidOrdersList.DOCDATE  | date:'dd.MM.yyyy'}}</td>
      <td style="">{{paidOrdersList.LOCALCOMP}}</td>
      <td style="">{{paidOrdersList.AUTHOR}}</td>
      <td style="">
        <a [routerLink]="['/edit-client', paidOrdersList.DOCCLIENTSID]">
          {{paidOrdersList.PARTNERNAMESTR}}
        </a>
      </td>
      <td style="text-align: right">{{paidOrdersList.DOCSUM | number:'1.2-2' }}</td>
      <td style="text-align: right">{{paidOrdersList.PAYDSUM | number:'1.2-2' }}</td>
      <td style="text-align: right">{{paidOrdersList.SHIPSUM | number:'1.2-2' }}</td>
      <td style="max-width: 15rem !important"><input pInputText type="text" [(ngModel)]="paidOrdersList.DOCNOTE1" readonly alt="{{paidOrdersList.DOCNOTE1}}"></td>
      <td style="max-width: 15rem !important"><input pInputText type="text" [(ngModel)]="paidOrdersList.DOCNOTE2" readonly alt="{{paidOrdersList.DOCNOTE2}}"></td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-paidOrdersList>
    <tr>
      <td colspan="13">
        <div class="p-p-2">
          <app-document-content-table [selectedDocumentId]="paidOrdersList.DOCID" [showFooterTotal]="true"></app-document-content-table>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="footer">
    <tr>
      <td></td>
      <td></td>
      <td style="text-align: right">{{totalPaidNowSum | number:'1.2-2' }}</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td style="text-align: right">{{totalInvoiceSum | number:'1.2-2' }}</td>
      <td style="text-align: right">{{totalPaidSum | number:'1.2-2' }}</td>
      <td style="text-align: right">{{totalShippedSum | number:'1.2-2' }}</td>
      <td></td>
      <td></td>
    </tr>
    <!--<tr>
      <td></td>
      <td></td>
      <td style="text-align: right">{{filteredPaidNowSum | number:'1.2-2' }}</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td style="text-align: right">{{filteredInvoiceSum | number:'1.2-2' }}</td>
      <td style="text-align: right">{{filteredPaidSum | number:'1.2-2' }}</td>
      <td style="text-align: right">{{filteredShippedSum | number:'1.2-2' }}</td>
      <td></td>
      <td></td>
    </tr>-->
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="13">Недавно оплаченных счетов нет</td>
    </tr>
  </ng-template>
</p-table>
